<template>
  <c-box>
    <FieldGroup
      v-if="technicalDetailAttributeGroup"
      :label="technicalDetailAttributeGroup.label"
      :attributes="technicalDetailAttributeGroup.attributes"
    >
    </FieldGroup>
    <FieldGroup
      v-if="categoryInformationAttributes"
      :label="String($t('productCard.basicInfo.categoryInformation'))"
      :attributes="categoryInformationAttributes"
    >
    </FieldGroup>
  </c-box>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ProductFieldGroup from "@/components/products/ProductFieldGroup.vue";
import { CBox } from "@chakra-ui/vue";

export default defineComponent({
  name: "ProductDataTechnicalDetails1",
  components: {
    FieldGroup: ProductFieldGroup,
    CBox,
  },
  props: {
    categoryInformationAttributes: {} as any,
    technicalDetailAttributeGroup: {} as any,
  },
});
</script>
